/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Ring2All Team
 📄 File: userActivityApi.ts
 🗓️ Created: 2025-12-02
 🧩 Description:
    API client functions for User Activity module
────────────────────────────────────────────────────────────────*/

import { buildApiUrl, getApiHeaders } from '../../../config/api';
import { ListUserActivityParams, ListUserActivityResponse } from '../types/userActivity.types';

/**
 * Fetch user activity logs (current user only)
 */
export async function fetchUserActivity(
  params: ListUserActivityParams,
  tenantSlug: string,
  userId: string | number
): Promise<ListUserActivityResponse> {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page.toString());
  if (params.limit) queryParams.append('limit', params.limit.toString());
  if (params.search) queryParams.append('search', params.search);
  if (params.action) queryParams.append('action', params.action);
  if (params.resource) queryParams.append('resource', params.resource);
  if (params.domainId) queryParams.append('domainId', params.domainId.toString());
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  if (params.sortBy) queryParams.append('sortBy', params.sortBy);
  if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

  const response = await fetch(
    buildApiUrl(`/api/audit-logs/me?${queryParams.toString()}`),
    {
      method: 'GET',
      headers: getApiHeaders(tenantSlug, userId),
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to fetch user activity');
  }

  return await response.json();
}

